<template>
	<div>
		<v-card-title class="custom-title"> {{ '내용' }} </v-card-title>
		<quill-editor
			class="custom-quill-editor"
			v-model="contentModel"
			ref="quillEditor"
			:options="editorOption"
			:style="editorStyles"
			@blur="onEditorBlur($event)"
			@focus="onEditorFocus($event)"
			@ready="onEditorReady($event)"
		>
		</quill-editor>
	</div>
</template>

<script>
	export default {
		name: 'ContentEditor',
		props: {
			height: {
				type: Number,
				default: 300,
			},
			value: String,
		},
		data: () => ({
			editorOption: {
				modules: {
					toolbar: [
						['bold', 'italic', 'underline', 'strike'],
						['blockquote', 'code-block'],
						[{ header: 1 }, { header: 2 }],
						[{ list: 'ordered' }, { list: 'bullet' }],
						[{ script: 'sub' }, { script: 'super' }],
						[{ indent: '-1' }, { indent: '+1' }],
						[{ direction: 'rtl' }],
						[{ size: ['small', false, 'large', 'huge'] }],
						[{ header: [1, 2, 3, 4, 5, 6, false] }],
						[{ font: [] }],
						[{ color: [] }, { background: [] }],
						[{ align: [] }],
						['clean'],
						// ['link', 'image', 'video'],
					],
				},
			},
		}),
		computed: {
			contentModel: {
				get() {
					return this.value;
				},
				set(value) {
					this.$emit('input', value);
				},
			},
			editor() {
				return this.$refs.quillEditor.quill;
			},
			editorStyles() {
				return {
					height: this.height + 'px',
				};
			},
		},
		methods: {
			onEditorBlur(quill) {
				console.log('editor blur!', quill);
			},
			onEditorFocus(quill) {
				console.log('editor focus!', quill);
			},
			onEditorReady(quill) {
				console.log('editor ready!', quill);
			},
		},
	};
</script>

<style scoped>
	.custom-title {
		font-size: 16px;
		color: rgba(0, 0, 0, 0.6);
		padding: 0 0 0 10px;
	}
	.custom-quill-editor .ql-container {
		height: 100%; /* 컨테이너가 부모의 높이를 차지하도록 설정 */
	}
	.custom-quill-editor .ql-editor {
		min-height: 200px; /* 에디터의 최소 높이 설정 */
	}
</style>
